import moment from 'moment'

export default {
  data(){
    return{
        search: '',
        pages: 1,
        current: 1,
        next: 1,
        previous: 1
    }
  },
  methods: {
    redirectURL(path) {
      localStorage.setItem('currentPage', this.$router.currentRoute.name)
      this.$router.push(path)
      return false
    },
    formErrors(errors){
      $(':input').removeClass('is-invalid')
      $('.errorForm').html('')
      $('#errorFound').hide()
      for (let key in errors){
        $('#'+key).addClass("is-invalid").next().html(errors[key])
        $('#errorFound').show()
      }
    },
    treatPagination(page, count, pages){
      this.pages = Math.ceil(pages)
      this.current =  parseInt(page)

      //first page
      if(this.current === 1) {
        $('#previous').addClass('disabled');
      } else {
        $('#previous').removeClass('disabled');
        this.previous = parseInt(page) - 1
      }

      //last page
      if(this.pages === this.current) {
        $('#next').addClass('disabled');
      } else {
        $('#next').removeClass('disabled');
        this.next = parseInt(page) + 1
      }
    },
    formatDate: function(data, formato) {
      if(data)
        if (formato == 'pt-br') {
          return (data.substr(0, 10).split('-').reverse().join('/'));
        } else {
          return (data.substr(0, 10).split('/').reverse().join('-'));
        }
    },
    string_to_slug(str) {
          str = str.replace(/^\s+|\s+$/g, ''); // trim
          str = str.toLowerCase();

          // remove accents, swap ñ for n, etc
          var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
          var to   = "aaaaeeeeiiiioooouuuunc------";
          for (var i=0, l=from.length ; i<l ; i++) {
              str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
          }

          str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
              .replace(/\s+/g, '-') // collapse whitespace and replace by -
              .replace(/-+/g, '-'); // collapse dashes

          return str;
        }
  },
  filters: {
    formatDate: function(value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
      }
    },
    formatDateTime: function(value) {
      if (value) {
        let date = moment(String(value)).format('DD/MM/YYYY')
        let time = moment(String(value)).format('hh:mm')
        return date + " às " + time
      }
    },
    sumNumber: function(value, num) {
      if (value) {
        return parseInt(value) + num
      }
    },
    formatPrice(value) {
      var val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    nameStatusOrder(status){
      let status_return = ''
      if(status === 'Pagamento pendente') status_return = '<span class="text-warning">Pagamento pendente</span>'
      if(status === 'Pagamento confirmado') status_return = '<span class="text-success">Pagamento confirmado</span>'
      if(status === 'Cancelado') status_return = '<span class="text-secondary">Cancelado</span>'
      if(status === 'Em análise') status_return = '<span class="text-info">Em análise</span>'
      return status_return
    },
    nameStatusPublication(status){
      let status_return = ''
      if(status === 1) status_return = '<span class="text-success">Download liberado</span>'
      if(status === 5) status_return = '<span class="text-success">Ativa</span>'
      if(status === 2) status_return = '<span class="text-warning">Aguardando envio</span>'
      if(status === 3) status_return = '<span class="text-secondary">Enviado</span>'
      if(status === 4) status_return = '<span class="text-danger">Vencida</span>'
      return status_return
    },
    nameFuelType(status){
      let status_return = ''
      if(status === 0) status_return = 'Nao Informado'
      if(status === 1) status_return = 'Gasolina'
      if(status === 2) status_return = 'Etanol'
      if(status === 3) status_return = 'Convertido para Etanol'
      return status_return
    },
    nameExpeditionStatus(status){
      let status_return = ''
      if(status === 1) status_return = 'Em Andamento'
      if(status === 2) status_return = 'Enviado'
      if(status === 3) status_return = 'Entregue'
      if(status === 4) status_return = 'Devolvido'
      return status_return
    },
    truncate(value, limit){
      if (value.length > limit) {
          value = value.substring(0, (limit - 3)) + '...';
      }

      return value
    }
  }
}

